<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->
<div class="main-container">
  <!-- ============================================================== -->
  <!-- Topbar - style you can find in header.scss -->
  <!-- ============================================================== -->

  <!-- <mat-toolbar color="primary" class="topbar telative ifca-header desktop-header p-16 position-fixed">

      <button mat-icon-button (click)="snav.toggle()" value="sidebarclosed" aria-label="close">
          <mat-icon>menu</mat-icon>
      </button>

      <div class="navbar-header">
          <a class="navbar-brand">
              <img src="assets/images/property-X.png" width="140" alt="">
              <span class="product-platform-title">Sales Online Platform</span>
          </a>
      </div>


      <span fxFlex></span>

      <app-header class="desktop-profile"></app-header>


  </mat-toolbar> -->


  <mat-toolbar class="ifca-top-header desktop-header position-fixed" style="z-index: 10">
    <div class="line-header" style="display: flex; align-items: center;">
      <button class="menu-burger" (click)="snav.toggle()" value="sidebarclosed" mat-icon-button>
        <mat-icon> menu </mat-icon>
      </button>

      <div class="selected-container">
        <!-- <div class="domain">{{ userService?.UserProfile?.name }}</div> -->

        <div class="selected-obj" style="font-size: 16px; font-weight:700;">
          {{ userService?.AccountName }}
        </div>
      </div>

      <button class="btn" mat-icon-button (click)="switchAccontDialog()" *ngIf="userService?.AccountList?.length > 1">
        <img class="menu-burger-2" src="assets\images\icon\header-switch-icon.svg"/>
      </button>

    </div>

    <!-- <div class="bread-crumb" style="width: 100%">
        <div style="display: inline; float: left">
          <span>Sales Online Platform</span>
        </div>
      </div> -->
  </mat-toolbar>


  <app-subheader class="mobile-header"></app-subheader>

  <!-- ============================================================== -->
  <mat-sidenav-container class="example-sidenav-container" [style.marginTop.px]="mobileQuery.matches ? 0 : 0"
    [ngClass]="{'minisidebar': minisidebar}">
    <!-- ============================================================== -->
    <!-- Sidebar - style you can find in sidebar.scss -->
    <!-- ============================================================== -->
    <mat-sidenav #snav id="snav" class="pl-xs position-fixed mobile-sidetop" [autoFocus]="false"
      [mode]="mobileQuery.matches ? 'side' : 'over'" fixedTopGap="0" [opened]="mobileQuery.matches"
      [disableClose]="mobileQuery.matches" (open)="sidebarOpened = true" (close)="sidebarOpened = false"
      [perfectScrollbar]="config">

      <app-sidebar class="app-sidebar"></app-sidebar>

    </mat-sidenav>
    <!-- ============================================================== -->
    <!-- Sidebar - style you can find in sidebar.scss -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- Right Sidebar - style you can find in rightsidebar.component.scss -->
    <!-- ============================================================== -->
    <mat-sidenav #end position="end" class="chat-panel" mode="over" opened="false">
      <div class="scroll">
        <mat-nav-list>

          <h3 mat-subheader class="text-uppercase font-weight-bold">Settings</h3>
          <mat-list-item>
            <mat-slide-toggle color="warn">RTL</mat-slide-toggle>
          </mat-list-item>
          <mat-list-item>
            <mat-slide-toggle color="warn">Boxed Layout</mat-slide-toggle>
          </mat-list-item>
          <!--<mat-list-item>
                  <mat-slide-toggle [(ngModel)]="minisidebar">Mini Sidebar</mat-slide-toggle>
                </mat-list-item>    -->
          <mat-divider></mat-divider>
          <h3 mat-subheader class="text-uppercase font-weight-bold">Colors</h3>
          <mat-list-item>
            <mat-checkbox color="warn" class="text-danger">Red</mat-checkbox>
          </mat-list-item>
          <mat-list-item>
            <mat-checkbox color="warn" class="text-megna">Teal
              Green</mat-checkbox>
          </mat-list-item>
          <mat-list-item>
            <mat-checkbox color="warn" class="text-info">Blue</mat-checkbox>
          </mat-list-item>
          <mat-list-item>
            <mat-checkbox color="warn">Dark</mat-checkbox>
          </mat-list-item>
        </mat-nav-list>
      </div>
    </mat-sidenav>

    <!-- ============================================================== -->
    <!-- Page container - style you can find in pages.scss -->
    <!-- ============================================================== -->
    <mat-sidenav-content class="page-wrapper">

      <div class="page-content">
        <app-breadcrumb></app-breadcrumb>
        <app-subheader class="desktop-header"></app-subheader>

        <router-outlet #router="outlet">
          <app-spinner></app-spinner>
          <div fxLayout="row" fxLayoutWrap="wrap" class="footer-menu" *ngIf="sharedService.footer == 1">
            <!-- column -->

            <div matRipple matRippleRadius="30" matRippleCentered="centered" matRippleUnbounded="unbounded"
              fxFlex.gt-sm="33.33" fxFlex.gt-xs="33.33" fxFlex="33.33" routerLink="/dashboards/dashboard1">
              <div class="centered menu-sub-icon">
                <div>

                  <mat-icon class="mat-icon material-icons color-footer">home</mat-icon>
                </div>
                <div class="footer-title">Dashboard 1</div>
              </div>
            </div>

            <div matRipple matRippleRadius="30" matRippleCentered="centered" matRippleUnbounded="unbounded"
              fxFlex.gt-sm="33.33" fxFlex.gt-xs="33.33" fxFlex="33.33" routerLink="/dashboards/dashboard2">
              <div class="centered menu-sub-icon">
                <div>
                  <mat-icon class="mat-icon material-icons color-footer">home</mat-icon>
                </div>
                <div class="footer-title">Dashboard 2</div>
              </div>
            </div>
            <div matRipple matRippleRadius="30" matRippleCentered="centered" matRippleUnbounded="unbounded"
              fxFlex.gt-sm="33.33" fxFlex.gt-xs="33.33" fxFlex="33.33" (click)="openBS()">
              <div class="centered menu-sub-icon">
                <div>
                  <mat-icon class="mat-icon material-icons color-footer">home</mat-icon>
                </div>
                <div class="footer-title">Dashboard 3</div>
              </div>
            </div>
          </div>

        </router-outlet>
      </div>



    </mat-sidenav-content>

    <!-- ============================================================== -->
    <!-- Page container - style you can find in pages.scss -->
    <!-- ============================================================== -->
  </mat-sidenav-container>
  <app-photo-zoom></app-photo-zoom>

</div>
